"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Option_1 = __importDefault(require("react-select/lib/Option"));

var ListDelimiter_1 = __importDefault(require("./markup/ListDelimiter"));

var ListItem_1 = __importDefault(require("./markup/ListItem"));

var Option =
/** @class */
function (_super) {
  __extends(Option, _super);

  function Option() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Option.prototype.render = function () {
    var _a = this.props,
        option = _a.option,
        isFocused = _a.isFocused,
        isSelected = _a.isSelected;
    return react_1.default.createElement(Option_1.default, __assign({}, this.props), option.hr ? react_1.default.createElement(ListDelimiter_1.default, null) : react_1.default.createElement(ListItem_1.default, {
      disabled: option.disabled,
      indent: option.indent,
      text: option.label,
      value: option.value,
      focused: isFocused,
      checked: isSelected,
      itemJsx: option.itemJsx,
      autoheight: option.autoheight,
      unselectable: option.unselectable,
      testId: option.testId
    }));
  };

  return Option;
}(react_1.default.Component);

exports.default = Option;